import React from "react";
import { useState } from "react";
import * as ManagedServiceStore from "../ManagedServiceStore";
import { ConfigFormField } from "../../organizations/OrganizationManagedServices";
import SquareButton from "../../general/SquareButton";
import { Button, Modal } from "../../components/Modal";
import { set } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const StoreManagedService = ({ organizationId, onDone }) => {
    const setConfig = (key) => (e) => {
        const newConfig = { ...newManagedService.configuration };
        set(newConfig, key, e.target.value);
        setNewManagedService({ ...newManagedService, configuration: newConfig });
    };

    const BoundConfigFormField = (key, name) => {
        return ConfigFormField(key, name, newManagedService.configuration, setConfig);
    };

    const [showModal, setShowModal] = useState(false);
    const [errors, setErrors] = useState([] as any[]);

    const [newManagedService, setNewManagedService] = useState({ type: 3, organizationId: organizationId, configuration: { name: "", logoUri: "" } } as any);

    const start = () => {
        setShowModal(true);
        setNewManagedService({ type: 3, organizationId: organizationId, configuration: { name: "", logoUri: "" } });
    };

    const complete = () => {
        ManagedServiceStore.CreateManagedService(organizationId, newManagedService)
            .then((response) => {
                setErrors([]);
                setShowModal(false);
                onDone();
            })
            .catch((error) => {
                if (error.response.data.errors && error.response.data.errors.length > 0) {
                    setErrors(error.response.data.errors);
                }
            });
    };

    return (
        <>
            <>
                <SquareButton className="col" onClick={start}>
                    Store
                    <br />
                    {/* @ts-ignore */}
                    <FontAwesomeIcon icon={["fad", "circle-plus"]} size="lg" className="text-blue-600"></FontAwesomeIcon>
                </SquareButton>
            </>
            <Modal 
                isOpen={showModal} 
                onClose={() => setShowModal(false)}
                title="New Store Managed Service"
                icon={["fad", "store"]}
                iconColor="text-blue-600"
                size="lg"
            >
                <div className="p-6">
                    {BoundConfigFormField("name", "Name")}
                    {BoundConfigFormField("logoUri", "Logo")}

                    {errors.length > 0 && (
                        <div className="bg-red-50 border border-red-200 rounded-md p-4 mb-4">
                            {errors.map((error, i) => (
                                <p key={i} className="text-red-800 text-sm">{error.message}</p>
                            ))}
                        </div>
                    )}
                </div>
                <div className="border-t border-gray-200 bg-gray-50 px-6 py-4 flex justify-end space-x-3">
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={complete}>
                        Create
                    </Button>
                </div>
            </Modal>
        </>
    );
};

export const RenderStoreRow = (configuration) => {
    return (
        <>
            <td>Name: {configuration.name}</td>
            <td></td>
        </>
    );
};
